import index from "./hwPolicy.vue";
import Vue from "../../comm.js";
// import Vue from '../../commwh.js'

new Vue({
  el: "#app",
  template: "<index/>",
  components: {
    index,
  },
});



// WEBPACK FOOTER //
// ./src/pages/landingPage/hwPolicy.js